module.exports = __webpack_public_path__ + "static/media/REMAN-SLIDE-3.912e2f7e.png";